import { render, staticRenderFns } from "./SetFreeModal.vue?vue&type=template&id=24efd950&"
import script from "./SetFreeModal.vue?vue&type=script&lang=js&"
export * from "./SetFreeModal.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

/* hot reload */
if (module.hot) {
  var api = require("C:\\a\\1\\s\\Locate2u.AppPortal\\node_modules\\vue-hot-reload-api\\dist\\index.js")
  api.install(require('vue'))
  if (api.compatible) {
    module.hot.accept()
    if (!api.isRecorded('24efd950')) {
      api.createRecord('24efd950', component.options)
    } else {
      api.reload('24efd950', component.options)
    }
    module.hot.accept("./SetFreeModal.vue?vue&type=template&id=24efd950&", function () {
      api.rerender('24efd950', {
        render: render,
        staticRenderFns: staticRenderFns
      })
    })
  }
}
component.options.__file = "src/pages/Billing/components/SetFreeModal.vue"
export default component.exports